module.exports = __webpack_public_path__ + "static/media/icon_data-devops.28270645.svg";